import React from 'react';
import { withAuthorization } from '../session';
import Modal from 'react-modal';
import Loader from 'react-loader-spinner';
import modalStyle from '../styles/modal'
import MessageItem from './MessageItem';
import EmptyList from '../useful/EmptyList';

Modal.setAppElement('#root');
class Message extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            messagesLoading: false,
            archivedLoading: false,
            messages: [],
            archived: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({
            messagesLoading: true,
            archivedLoading: true,
        });
        this.listenMessages();
    }

    componentWillUnmount() {
        this.props.firebase.messages().off();
    }

    listenMessages = () => {
        this.props.firebase.messages().off();
        
        this.props.firebase.messages().orderByChild("archived").equalTo(false).on('value', (snapshot) => {
            const messageObject = snapshot.val();
            let list = [];
            if (messageObject) {
                list = Object.keys(messageObject).map(key => ({
                    ...messageObject[key],
                    uid: key,
                }));
            }
            this.setState({
                messagesLoading: false,
                messages: list.reverse(),
            });
        });
        this.props.firebase.messages().orderByChild("archived").equalTo(true).on('value', (snapshot) => {
            const messageObject = snapshot.val();
            let list = [];
            if (messageObject) {
                list = Object.keys(messageObject).map(key => ({
                    ...messageObject[key],
                    uid: key,
                }));
            }

            this.setState({
                archivedLoading: false,
                archived: list.reverse(),
            });
        });
    }

    handleArchive = (item) => {
        const itemUid = item.uid;
        item.uid = null;
        this.props.firebase
            .message(itemUid)
            .set({
                ...item,
                archived: true,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo archivar este mensaje.");
                console.log(error);
            });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {

        const { messagesLoading, archivedLoading, messages, archived, error } = this.state;

        const time = new Date().getTime();
        const messageList = messages.length > 0 ?
            messages.map((item, i) => {
                return (
                    <MessageItem
                        key={item.uid + time}
                        item={item}
                        handleArchive={this.handleArchive}
                    />
                )
            }) : <EmptyList />;

        const archivedList = archived.length > 0 ?
            archived.map((item, i) => {
                return (
                    <MessageItem
                        key={item.uid + time}
                        item={item}
                    />
                )
            }) : <EmptyList />;

        return (
            <div >


                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className="nav-link active" id="messages-tab" data-toggle="tab" href="#messages" role="tab" aria-controls="messages" aria-selected="true"><h6> Listado de mensajes</h6></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="archived-tab" data-toggle="tab" href="#archived" role="tab" aria-controls="archived" aria-selected="false"><h6>Archivados</h6></a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active " id="messages" role="tabpanel" aria-labelledby="messages-tab">
                        {(!messagesLoading) ?
                            <div className="row p-1">
                                {messageList}
                            </div>
                            :
                            <div className="nav justify-content-center">
                                <Loader className="mt-4"
                                    type="ThreeDots"
                                    color="#263238"
                                    height={60}
                                    width={60}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                    <div className="tab-pane fade" id="archived" role="tabpanel" aria-labelledby="archived-tab">
                        {(!archivedLoading) ?
                            <div className="row p-1">
                                {archivedList}
                            </div>
                            :
                            <div className="nav justify-content-center">
                                <Loader className="mt-4"
                                    type="ThreeDots"
                                    color="#263238"
                                    height={60}
                                    width={60}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </div>



                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Message);